import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import { closeModal, createEmailTemplate, gotoUrl } from "../../actions";
import styles from "../../components/Modal.module.css";

export class CreateEmailTemplateModal extends Component {
  constructor(props) {
    super(props);
    this.create = this.create.bind(this);
    this.nameRef = createRef();
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
  }

  create(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId } = this.props;

    this.props
      .createEmailTemplate(
        accountId,
        {
          name: this.nameRef?.current.value,
          accountId,
        },
        true
      )
      .then((data) => {
        const nextId = data.data.id;
        return this.props.gotoUrl(
          `/clients/${accountId}/email-templates/${nextId}`
        );
      })
      .then(this.props.closeModal);
  }

  render() {
    return (
      <Modal>
        <ModalHeader>Create Email Template</ModalHeader>
        <ModalContent>
          <form onSubmit={this.create} className={styles.flex}>
            <label>Name</label>
            <input ref={this.nameRef} autoFocus />
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.create}>Create</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

CreateEmailTemplateModal.propTypes = {
  createEmailTemplate: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const accountId = params.accountId;

  return {
    accountId,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  createEmailTemplate,
  gotoUrl,
})(CreateEmailTemplateModal);
